/*global Countdown, Backbone*/
var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var template = require('./build/templates');

'use strict';

module.exports = Backbone.View.extend({
    template: template['home'],
    className: 'view-home',
    /**
     *
     */
    initialize: function (options) {
      _.bindAll(this, 'render');

      this.listenTo(this.model, 'change:time_months', this.changeMonths);
      this.listenTo(this.model, 'change:time_hours', this.changeHours);
      this.listenTo(this.model, 'change:time_minutes', this.changeMinutes);
      this.listenTo(this.model, 'change:time_days', this.changeDays);
      this.listenTo(this.model, 'change:time_seconds', this.changeSeconds);
    }
    /**
     *
     */
    , render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      
      this.changeMonths(this.model);
      this.changeDays(this.model);
      this.changeHours(this.model);
      this.changeMinutes(this.model);
      this.changeSeconds(this.model);

      return this;
    }
    , customCSS: function(rootView) {
      rootView = rootView || $('body');

      var styles = this.model.get('styles');

      //Font font
      if(styles.font) 
        rootView.css('font-family', styles.font);

      //Colors\\
      //copy_color
      if(styles.colors.copy_color) 
        rootView.find('.countdown-container .intro-text').css('color', styles.colors.copy_color);
      //column_label_color
      if(styles.colors.column_label_color) 
        rootView.find('.countdown-unit-label').css('color', styles.colors.column_label_color);
      //number_color
      if(styles.colors.number_color) 
        rootView.find('.countdown-value').css('color', styles.colors.number_color);
      //colon_color
      if(styles.colors.colon_color) 
        rootView.find('.colon .text').css('color', styles.colors.colon_color);

      //Background colors\\
      //number_cell_background
      if(styles.colors.number_cell_background) 
        rootView.find('.countdown-value').css('background-color', styles.colors.number_cell_background);
      //counter_background_color
      if(styles.colors.counter_background_color) 
        rootView.find('.countdown-container').css('background-color', styles.colors.counter_background_color);
      //main_background_color
      if(styles.colors.main_background_color) 
        rootView.css('background-color', styles.colors.main_background_color);
    }
    /**
     *
     */
    ,changeMonths: function(model, value, options){
        var value = value || model.get('time_months');
        $('.countdown-months .countdown-value').html(value < 10? '0'+value : value)
        if(value === 1){
            this.$el.find('.countdown-months .countdown-unit-label').html('Month');
        } else if(model.previous('time_months') === 1){
            this.$el.find('.countdown-months .countdown-unit-label').html('Months');
        }
    }
    /**
    /**
     *
     */
    ,changeDays: function(model, value, options){
        var value = value || model.get('time_days');
        $('.countdown-days .countdown-value').html(value < 10? '0'+value : value)
        if(value === 1){
            this.$el.find('.countdown-days .countdown-unit-label').html('Day');
        } else if(model.previous('time_days') === 1){
            this.$el.find('.countdown-days .countdown-unit-label').html('Days');
        }
    }
    /**
     *
     */
    ,changeHours: function(model, value, options){
        var value = value || model.get('time_hours');
        $('.countdown-hours .countdown-value').html(value < 10? '0'+value : value)
        if(value === 1){
            this.$el.find('.countdown-hours .countdown-unit-label').html('Hour');
        } else if(model.previous('time_hours') === 1){
            this.$el.find('.countdown-hours .countdown-unit-label').html('Hours');
        }

    }
    /**
     *
     */
    ,changeMinutes: function(model, value, options){
        var value = value || model.get('time_minutes');
        $('.countdown-minutes .countdown-value').html(value < 10? '0'+value : value);
        if(value === 1){
            this.$el.find('.countdown-minutes .countdown-unit-label').html('Min');
        } else if(model.previous('time_minutes') === 1){
            this.$el.find('.countdown-minutes .countdown-unit-label').html('Mins');
        }

    }
    /**
     *
     */
    ,changeSeconds: function(model, value, options){
        var value = value || this.model.get('time_seconds');

        this.$('.countdown-seconds .countdown-value').html(value < 10? '0'+value : value);
        if(value === 1){
            this.$('.countdown-seconds .countdown-unit-label').html('Sec');
        } else if(this.model.previous('time_seconds') === 1){
            this.$('.countdown-seconds .countdown-unit-label').html('Secs');
        }

    }
  });


//////////////////
// WEBPACK FOOTER
// ./node_modules/tswdg-countdown/index.js
// module id = 268
// module chunks = 0